export const SET_DOKUMENTKATEGORIE = "setDokumentkategorie";
